import o from "google-libphonenumber";
const e = o.PhoneNumberUtil.getInstance();
function a(t) {
  try {
    const r = e.parse(t);
    return e.format(
      r,
      o.PhoneNumberFormat.INTERNATIONAL
    );
  } catch {
    return t;
  }
}
export {
  a as default
};
